import React, {useEffect, useState} from 'react';

import {List} from 'components/list/List';
import {Spinner} from 'components/spinner';
import {loadMetadata, selectMetadata} from 'entities/metadata';
import {selectEntityData} from 'modules/data';
import {loadFormPageData} from 'modules/data/data-actions';
import {IListEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

import './tooltip-list.less';

interface ITooltipListProps {
    entityName?: string;
    url?: string;
}

export const TooltipList = ({entityName = '', url}: ITooltipListProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useAppDispatch();
    const listMeta = useAppSelector(state => selectMetadata(entityName, EEntityType.LIST)(state));
    const listData = useAppSelector(state => selectEntityData(entityName, EEntityType.FORM)(state) as IListEntityData);
    useEffect(() => {
        (async () => {
            if (!listMeta) {
                setIsLoading(true);
                await dispatch(loadMetadata(entityName, EEntityType.LIST));
                setIsLoading(false);
            }
            if (!listData) {
                setIsLoading(true);
                await dispatch(loadFormPageData(entityName, url));
                setIsLoading(false);
            }
        })();
    }, []);

    return (
        isLoading
            ? <Spinner />
            : (
                <div className="tooltip-list">
                    <List
                        listData={listData}
                        meta={listMeta}
                        showTitle={false}
                    />
                </div>
            )
    );
};
